import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../components/ui/command';
import { Button } from '../../../components/ui/button';
import { Check, ChevronsUpDown } from 'lucide-react';

/** Searchable single-select combobox. options: [{id, name}] */
export default function SearchSelect({ value, onChange, options = [], placeholder = 'Select…', searchPlaceholder = 'Type to search…', testid, allowAll = false, allLabel = 'All', className = '' }) {
  const [open, setOpen] = useState(false);
  const opts = Array.isArray(options) ? options : [];
  const selected = opts.find((o) => o.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testid}
          className={`h-10 justify-between bg-white border-slate-200 font-medium text-[13px] hover:bg-slate-50 hover:border-violet-300 transition-colors ${selected ? 'text-slate-900' : 'text-slate-400'} ${className}`}
        >
          <span className="truncate">{selected ? selected.name : (allowAll && !value ? allLabel : placeholder)}</span>
          <ChevronsUpDown className="w-3.5 h-3.5 shrink-0 opacity-50 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[220px] bg-white" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} className="text-[13px]" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList className="max-h-64">
            <CommandEmpty className="py-4 text-center text-[12px] text-slate-400">No match found.</CommandEmpty>
            <CommandGroup>
              {allowAll && (
                <CommandItem value={allLabel} onSelect={() => { onChange(''); setOpen(false); }} className="text-[13px]" data-testid={testid ? `${testid}-all` : undefined}>
                  <Check className={`mr-2 h-3.5 w-3.5 ${!value ? 'opacity-100 text-violet-600' : 'opacity-0'}`} />{allLabel}
                </CommandItem>
              )}
              {opts.map((o) => (
                <CommandItem
                  key={o.id}
                  value={o.name}
                  onSelect={() => { onChange(o.id); setOpen(false); }}
                  className="text-[13px] cursor-pointer"
                  data-testid={testid ? `${testid}-opt-${o.id}` : undefined}
                >
                  <Check className={`mr-2 h-3.5 w-3.5 ${value === o.id ? 'opacity-100 text-violet-600' : 'opacity-0'}`} />
                  {o.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
